import { Button, Box } from "@mui/material";
import DropIn from "braintree-web-drop-in-react";
import { useEffect, useRef, useState } from "react";
import { getClientToken, putSubscription, updateSubscription } from "../../lib/connector/paypalQueries";

function SubscribeButton({ planId, userData, setShowAddPaymentDialog,
  paymentMethodLoading, setPaymentMethodLoading, canCancel, onSuccess, subscriptionId, subscribe }: {
    planId: string,
    userData: any,
    setShowAddPaymentDialog: (show: boolean) => void,
    paymentMethodLoading: boolean,
    setPaymentMethodLoading: (loading: boolean) => void,
    canCancel: boolean,
    onSuccess?: () => void,
    subscriptionId?: string,
    subscribe?: boolean
  }) {
  const [clientToken, setClientToken] = useState<string | null>(null);
  const [dropinReady, setDropinReady] = useState(false);
  const dropinInstance = useRef<any>(null);

  useEffect(() => {
    // Fetch client token from your server
    const fetchClientToken = async () => {
      if (userData != null && clientToken == null) {
        try {
          getClientToken(userData.userId).then((response) => {
            setClientToken(JSON.parse(response.body).clientToken);
          });
        } catch (error) {
          console.error("Error fetching client token:", error);
        }
      }
    };

    fetchClientToken();
  }, [userData]);

  const handlePayment = async () => {
    if (!dropinInstance.current) {
      alert("Payment system not ready. Please try again.");
      return;
    }

    try {
      setPaymentMethodLoading(true);

      // Request payment method from Drop-in
      const result = await dropinInstance.current.requestPaymentMethod();

      if (subscribe) {
        // Create subscription with payment nonce
        if (subscriptionId) {
          await updateSubscription(userData.userId, result.nonce, subscriptionId, planId);
        } else {
          await putSubscription(userData.userId, result.nonce, planId);
        }

        // Close the payment dialog first
        setShowAddPaymentDialog(false);

        // Call the success callback to close the FreeTierModal
        if (onSuccess) {
          onSuccess();
        }
      } else {
        // Just adding/updating payment method, close the dialog
        setShowAddPaymentDialog(false);
        if (onSuccess) {
          onSuccess();
        }
      }
    }
      catch (error) {
        alert(`Payment failed: ${error instanceof Error ? error.message : 'Unknown error'}`);
      } finally {
        setPaymentMethodLoading(false);
      }
    };

  // Only render Drop-in when client token is available
  if (!clientToken) {
    return <div>Loading payment options...</div>;
  }

  return (
    <>
      <DropIn
        options={{
          authorization: clientToken,
          vault: true,
          hiddenVaultedPaymentMethodTypes: subscribe ? [] : ["card", "paypal", 'paypalCredit'],
        }}
        preselectVaultedPaymentMethod={false}
        onInstance={(instance) => {
          dropinInstance.current = instance;
          setDropinReady(true);
        }}
        onError={(error) => {
        }}
        onPaymentMethodRequestable={() => {
        }}
        onNoPaymentMethodRequestable={() => {
        }}
      />
      <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 2 }}>
        <Button
          variant="contained"
          color="primary"
          onClick={handlePayment}
          disabled={!dropinReady || paymentMethodLoading}
        >
          {paymentMethodLoading ? "Processing..." : subscribe ? "Subscribe" : "Save Payment Method"}
        </Button>
      </Box>
    </>
  );
}

export default SubscribeButton;